import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useApp } from "@/context/AppContext";
import { docLabel } from "@/lib/api";

const CALC_LABEL = { egi: "EGI", noi: "NOI", ads: "Debt Svc", ltv: "LTV", dscr: "DSCR", debt_yield: "Debt Yield" };

const prep = (text) =>
  (text || "").replace(/\[\[(doc|calc|policy|rule):([^\]]+)\]\]/g, (_, t, v) => {
    if (t === "doc") {
      const [id, page] = v.split(":");
      return ` [${docLabel(id)} p.${page || 1}](cite:doc:${id}:${page || 1})`;
    }
    if (t === "policy" || t === "rule") return ` [${v}](cite:${t}:${v})`;
    return ` [${CALC_LABEL[v] || v} calc](cite:calc:${v})`;
  }).replace(/\[\[([^\]]*)\]\]/g, "`$1`");

export function RichText({ text, metrics }) {
  const { openSource } = useApp();
  const A = ({ href, children }) => {
    if (!href?.startsWith("cite:")) return <a href={href} className="text-sky-600 underline" target="_blank" rel="noreferrer">{children}</a>;
    const [, t, id, page] = href.split(":");
    const isDoc = t === "doc";
    const cls = { doc: "border-sky-500/40 text-sky-700 hover:bg-sky-600/15", calc: "border-violet-500/40 text-violet-700 hover:bg-violet-500/15", policy: "border-emerald-500/40 text-emerald-700 hover:bg-emerald-500/15", rule: "border-indigo-400/40 text-indigo-700 hover:bg-indigo-500/15" }[t];
    const open = () => {
      if (isDoc) openSource({ doc_id: id, page });
      else if (t === "calc") openSource({ metric: metrics?.[id], metrics });
      else openSource(t === "policy" ? { policy_id: id } : { rule_id: id });
    };
    return (
      <button
        data-testid={`cite-${t}-${id}${isDoc ? `-p${page}` : ""}`}
        onClick={open}
        className={`inline-flex items-center align-baseline text-[10px] num px-1.5 py-[1px] rounded border mx-0.5 transition-colors ${cls}`}
      >
        {children}
      </button>
    );
  };
  return (
    <div className="md">
      <ReactMarkdown remarkPlugins={[remarkGfm]} urlTransform={(u) => u} components={{ a: A }}>
        {prep(text)}
      </ReactMarkdown>
    </div>
  );
}
